import moment, { Moment } from 'moment';
import { FilterState, SortState as ActivitySortState } from '../components/transactions/activity/Activity';
import { OrderFilters, SortState as OrderStatusSortState } from '../components/transactions/orderstatus/OrderStatus';
import { Features, ProfileClient, RBCDict } from './types';

const cookieName = 'RBCDict';
const rbcDict: RBCDict = document.cookie.split(';')
  .find((cookie) => cookie.includes(cookieName))?.trim()
  .slice(`${cookieName}=`.length)
  .split('&')
  .reduce((acc, kv) => {
    const [key, val] = kv.split('=');
    return { ...acc, [key]: val };
  }, {} as RBCDict) || {} as RBCDict;


// Session Storage

type StoredState = {
  activity?: {
    filterState: FilterState,
    sortState: ActivitySortState,
    showCount: number,
  },
  orderStatus?: {
    filterState: OrderFilters,
    sortState: OrderStatusSortState,
    showCount: number,
    expandedStates: { [key: string]: boolean }
  },
  profileClient?: ProfileClient,
  features?: Features,
  showInterceptModal?: {emailAddress?: string, showIntercept: boolean},
  SGID?: string
};

const SESSION_KEY = 'rbc_di_session';

const getStoredState: () => StoredState = () => {
  const storedState = JSON.parse(sessionStorage.getItem(SESSION_KEY)) || {}
  if (storedState.activity) {
    storedState.activity.filterState.startDate = moment(storedState.activity.filterState.startDate);
    storedState.activity.filterState.endDate = moment(storedState.activity.filterState.endDate);
  }
  return storedState;
};

const setStoredState = (state: StoredState) =>
  sessionStorage.setItem(SESSION_KEY, JSON.stringify({ ...getStoredState(), ...state }));


// Local Storage

type Storage = {
  modExpiry?: Moment,
  SGID?: string
};

const STORAGE_KEY = 'rbc_di_storage';

const getStorage: () => Storage = () => {
  const storedState: Storage = JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  if (storedState.modExpiry) storedState.modExpiry = moment(storedState.modExpiry);
  return storedState;
};

const setStorage = (state: Storage) =>
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...getStorage(), ...state }));

const SGID = rbcDict.SGID?.slice(-18);
const didSessionUpdate = getStorage().SGID !== SGID;
if (didSessionUpdate) setStorage({ SGID });

export { rbcDict, getStoredState, setStoredState, getStorage, setStorage, didSessionUpdate };
